<template>
  <div>
    <div>
      <div class="poster" v-show="poster">
        <div class="optionsBg"></div>
        <span v-if="this.$route.query.type == 'live'" class="live_status"
          :style="{ background: this.videoinfo.lState == 1 ? '#FFB441' : this.videoinfo.lState == 2 ? '#4C9BC7' : this.videoinfo.lState == 3 ? '#FF7720' : this.videoinfo.lState == 0 ? '#B40000' : '', }">
          {{ videoinfo.lState == 0 ? '未开始' : videoinfo.lState == 1 ? '正在直播' : videoinfo.lState == 2 ? '直播结束' : videoinfo.lState == 3 ? '直播回顾' : '' }}
        </span>
        <img class="bg" v-bind:style="{ height: `${videoHeight}px` }" :src="posterUrl" alt="">
        <img class="play" @click='playVideo' src="../../assets/images/play.png" alt="">
      </div>
      <div class="prism-player" id="J_prismPlayer" v-show="!poster" style="z-index: 1"
        v-bind:style="{ height: `${videoHeight}px`, width: '862px' }"></div>
      <!--      <div  class="prism-player" id="J_prismPlayer"   style="z-index: 1"  v-bind:style="{height:`${videoHeight}px`}"></div>-->
    </div>
  </div>
</div></template>
<script>
import Chimee from "chimee";
import weui from "weui.js";
import bus from "../../components/bus/index";
import loginService from '../../plugin/extendFn/loginService';
import AppSetting from '../../AppSetting';
// import ChimeeMobilePlayer from 'chimee-mobile-player' //移动端
// import chimeePluginControlbar from 'chimee-plugin-controlbar';
// Chimee.install(chimeePluginControlbar);

export default {
  data() {
    return {
      videoHeight: null,
      isQuestion: false,
      chimee: null,
      poster: true,
      status: "",
      // isShow:false,
      list: [],
      active: 1,
      // answer:[],
      // rightanswer:[],
      dialog: "",
      ra_wxUser: null,
      last: 0,

      // posterUrl:null,
    };
  },
  props: {
    videoinfo: {
      type: Object,
    },
    isCharge: {
      type: Boolean,
    },
    isCanPlay: {
      type: Boolean,
    },
    type: {
      type: Number,
    },
    // poster,
    // isQuestion,
  },
  async mounted() {
    this.ra_wxUser = await loginService.getLoginUser();

    // console.log('视频数据',this.videoinfo)
    sessionStorage.setItem("ilnmtime", 0);

    let sUserAgent = navigator.userAgent.toLowerCase();
    if (
      /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
        sUserAgent
      )
    ) {
      //跳转移动端页面
      let docWidth = document.documentElement.clientWidth;
      let videoHeight = (docWidth * 9) / 16;
      this.videoHeight = videoHeight;
    } else {
      this.videoHeight = 490;
    }
    // console.log('视频mounted',this.videoinfo.vViewUrl)
    this.$nextTick(() => {
      this.chimeeConfig();
    });
  },
  methods: {
    login() {
      loginService.login(this.$router).then((loginUser) => {
        this.ra_wxUser = loginUser;
      });
    },
    async playVideo(value) {
      //校验用户是否登录
      if (await loginService.isNotLogin()) {
        this.login();
      } else {
        this.ra_wxUser = await loginService.getLoginUser();
        // if (this.valideEmail() == false) {
        //   this.toast("请完善注册信息");
        //   this.$router.push({
        //     path: "/userinfo",
        //   });

        //   return;
        // }

        if (this.$route.query.type == "video") {
          if (this.isCharge) {
            //需要支付 走父级的支付方法
            this.$emit("funisCharge", 1); //需要支付
            return false;
          } else {
            if(this.isCanPlay) {
              this.poster = false;
              this.chimee.play();
            } else {
              this.$message.warning('可播放时间为:'+ this.videoinfo.vOpenBeginTime+'至' + this.videoinfo.vOpenEndTime);
              return false;
            }
            
          }
          this.$postHttp(AppSetting.baseUrl + "/video/count", {
            vid: this.$route.query.videoId,
          }).then((res) => {
            if (res.data.code == 0) {
            }
          });
        } else {
          if (this.videoinfo.lState == 0) {
            //未开始
            if (this.isCharge) {
              //需要支付 走父级的支付方法
              this.$emit("funisCharge", 1); //需要支付
              return false;
            } else {
              this.$message.warning("直播未开始");
              return false;
            }
          }
          if (this.videoinfo.lState == 2) {
            this.$message.warning("直播已结束");
            return false;
          } else if (this.videoinfo.lState == 1) {
            //直播中
            if (this.isCharge) {
              //需要支付 走父级的支付方法
              this.$emit("funisCharge", 1); //需要支付
              return false;
            } else {
              if(this.isCanPlay) {
                this.poster = false;
                this.chimee.play();
              } else {
                this.$message.warning('可播放时间为:'+ this.videoinfo.lOpenBeginTime+'至' + this.videoinfo.lOpenEndTime);
                return false;
              }
            }
          } else if (this.videoinfo.lState == 3) {
            if (this.isCharge) {
              //需要支付 走父级的支付方法
              this.$emit("funisCharge", 1); //需要支付
              return false;
            } else {
              if(this.isCanPlay) {
                this.poster = false;
                this.chimee.play();
              } else {
                this.$message.warning('可播放时间为:'+ this.videoinfo.lOpenBeginTime+'至' + this.videoinfo.lOpenEndTime);
                return false;
              }
            }
          }
        }
      }
    },
    chimeeConfig() {
      let type = this.$route.query.type;

      let sUserAgent = navigator.userAgent.toLowerCase();
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          sUserAgent
        )
      ) {
        //跳转移动端页面

        let isios;
        let u = navigator.userAgent;
        if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
          isios = true;
        }
        // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

        this.chimee = new Aliplayer({
          id: "J_prismPlayer",
          width: "100%",
          source: this.videoinfo.vViewUrl,
          // source: 'https://www.w3school.com.cn/example/html5/mov_bbb.mp4',
          // isLive: this.$route.query.type == 'video' ? false : this.videoinfo.lState == 3 ? false : true,
          isLive: isios ? false : true, //直播全屏切换小屏的问题
          // isLive: this.$route.query.type == 'live'&&this.videoinfo.lState != 3 ? true : false,
          playsinline: true, //H5是否内置播放
          useH5Prism: true, //强制H5播放器

          rePlay: false,
          WebView: "allowsInlineMediaPlayback",
          preload: true, //播放器自动加载
          controlBarVisibility: "hover", //控制面板的实现 ‘click’ 点击出现、‘hover’ 浮动出现、‘always’ 一直在
          allowsInlineMediaPlayback: true,
          autoplay: false,
          // useH5Prism:true,//使用自适应播放器，然后设置useH5Prism属性为true
          enableSystemMenu: true, //是否允许系统右键菜单显示，默认为false。
          // autoPlayDelay:2,//延迟播放时间，单位为秒。
          loadDataTimeout: 5, // 缓冲多长时间后，提示用户切换低清晰度，默认：20秒。
          showBarTime: "10000", //控制栏自动隐藏时间（ms）
          cover: this.posterUrl,
          //支持播放地址播放,此播放优先级最高
          disableSeek: this.$route.query.type == "video" ? false : true, //禁用进度条的Seek，默认为false，仅Flash支持
          skinLayout: [
            {
              name: "bigPlayButton",
              align: "blabs",
              x: 30,
              y: 80,
            },
            {
              name: "H5Loading",
              align: "cc",
            },
            {
              name: "errorDisplay",
              align: "tlabs",
              x: 0,
              y: 0,
            },
            {
              name: "infoDisplay",
            },
            {
              name: "tooltip",
              align: "blabs",
              x: 0,
              y: 56,
            },
            {
              name: "thumbnail",
            },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: [
                {
                  name: "progress",
                  align: "blabs",
                  x: 0,
                  y: 44,
                },
                {
                  name: "playButton",
                  align: "tl",
                  x: 15,
                  y: 12,
                },
                {
                  name: "timeDisplay",
                  align: "tl",
                  x: 10,
                  y: 7,
                },
                {
                  name: "fullScreenButton",
                  align: "tr",
                  x: 10,
                  y: 12,
                },
                {
                  name: "subtitle",
                  align: "tr",
                  x: 15,
                  y: 12,
                },
                {
                  name: "volume",
                  align: "tr",
                  x: 5,
                  y: 10,
                },
              ],
            },
          ],
        },
          () => {
            // 展示水印功能
            if(this.videoinfo.showWatermark) {
              console.log('播放器创建成功');
            // 创建水印元素
              var watermark = document.createElement('div');
              watermark.textContent = this.ra_wxUser.uPhone ? this.ra_wxUser.uPhone : this.ra_wxUser.uId; // 水印文本
              watermark.style.position = 'absolute';
              watermark.style.top = '10px';
              watermark.style.right = '10px';
              watermark.style.color = 'black';
              watermark.style.opacity = '0.5'; // 设置透明度为 50%
              watermark.style.fontSize = '12px';
              watermark.style.zIndex = 999; // 确保水印显示在最上层

              // 获取播放器容器
              var playerContainer = document.getElementById('J_prismPlayer');
              playerContainer.appendChild(watermark);

              // 初始化水印移动参数
              let xSpeed = 1; // x 轴移动速度
              let ySpeed = 1; // y 轴移动速度
              let currentX = parseInt(watermark.style.left) || 0;
              let currentY = parseInt(watermark.style.top) || 0;

              // 定时更新水印位置
              let moveInterval;
              function startMoving() {
                moveInterval = setInterval(() => {
                  // 获取播放器容器的宽度和高度
                  const containerWidth = playerContainer.offsetWidth;
                  const containerHeight = playerContainer.offsetHeight;
                  // 获取水印元素的宽度和高度
                  const watermarkWidth = watermark.offsetWidth;
                  const watermarkHeight = watermark.offsetHeight;

                  // 更新位置
                  currentX += xSpeed;
                  currentY += ySpeed;

                  // 检查边界并改变方向
                  if (currentX + watermarkWidth > containerWidth || currentX < 0) {
                    xSpeed = -xSpeed;
                  }
                  if (currentY + watermarkHeight > containerHeight || currentY < 0) {
                    ySpeed = -ySpeed;
                  }

                  // 更新水印的位置
                  watermark.style.left = currentX + 'px';
                  watermark.style.top = currentY + 'px';
                }, 50);
              }

              function stopMoving() {
                clearInterval(moveInterval);
              }

              // 随机生成 15 - 20 秒的展示时间
              const showTime = Math.floor(Math.random() * (20 - 15 + 1) + 15) * 1000;
              const hideTime = 30 * 1000;

              function showWatermark() {
                watermark.style.display = 'block';
                startMoving();
                setTimeout(() => {
                  hideWatermark();
                }, showTime);
              }

              function hideWatermark() {
                watermark.style.display = 'none';
                stopMoving();
                setTimeout(() => {
                  showWatermark();
                }, hideTime);
              }

              // 开始循环
              showWatermark();

              // // 处理全屏事件，确保全屏时水印也正常显示
            this.chimee.on('fullscreenchange',  ()=> {
              if (this.chimee.isFullscreen()) {
                // 全屏时调整水印样式
                watermark.style.position = 'fixed';
                watermark.style.left = '10px';
                watermark.style.top = '10px';
                currentX = 10;
                currentY = 10;
              } else {
                // 退出全屏时恢复水印样式
                watermark.style.position = 'absolute';
                watermark.style.left = '10px';
                watermark.style.top = '10px';
                currentX = 10;
                currentY = 10;
              }
            })

            }
            


          
          }
        );
      } else {
        this.chimee = new Aliplayer({
          id: "J_prismPlayer",
          width: "100%",
          source: this.videoinfo.vViewUrl,
          // source: 'https://www.w3school.com.cn/example/html5/mov_bbb.mp4',

          isLive:
            this.$route.query.type == "video"
              ? false
              : this.videoinfo.lState == 3
                ? false
                : true,
          // isLive: this.$route.query.type == 'live'&&this.videoinfo.lState != 3 ? true : false,
          playsinline: true, //H5是否内置播放
          useH5Prism: true, //强制H5播放器

          rePlay: false,
          WebView: "allowsInlineMediaPlayback",
          preload: true, //播放器自动加载
          controlBarVisibility: "hover", //控制面板的实现 ‘click’ 点击出现、‘hover’ 浮动出现、‘always’ 一直在
          allowsInlineMediaPlayback: true,
          autoplay: false,
          // useH5Prism:true,//使用自适应播放器，然后设置useH5Prism属性为true
          enableSystemMenu: true, //是否允许系统右键菜单显示，默认为false。
          // autoPlayDelay:2,//延迟播放时间，单位为秒。
          loadDataTimeout: 5, // 缓冲多长时间后，提示用户切换低清晰度，默认：20秒。
          showBarTime: "10000", //控制栏自动隐藏时间（ms）
          cover: this.posterUrl,
          //支持播放地址播放,此播放优先级最高
          disableSeek: this.$route.query.type == "video" ? false : true, //禁用进度条的Seek，默认为false，仅Flash支持
          //自定义 不要进度条
          skinLayout: [
            {
              name: "bigPlayButton",
              align: "blabs",
              x: 30,
              y: 80,
            },
            {
              name: "H5Loading",
              align: "cc",
            },
            {
              name: "errorDisplay",
              align: "tlabs",
              x: 0,
              y: 0,
            },
            {
              name: "infoDisplay",
            },
            {
              name: "tooltip",
              align: "blabs",
              x: 0,
              y: 56,
            },
            {
              name: "thumbnail",
            },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: [
                {
                  name: "progress",
                  align: "blabs",
                  x: 0,
                  y: 44,
                },
                {
                  name: "playButton",
                  align: "tl",
                  x: 15,
                  y: 12,
                },
                {
                  name: "timeDisplay",
                  align: "tl",
                  x: 10,
                  y: 7,
                },
                {
                  name: "fullScreenButton",
                  align: "tr",
                  x: 10,
                  y: 12,
                },
                {
                  name: "subtitle",
                  align: "tr",
                  x: 15,
                  y: 12,
                },
                {
                  name: "volume",
                  align: "tr",
                  x: 5,
                  y: 10,
                },
              ],
            },
          ],
        },
          () => {
             // 展示水印功能
             if(this.videoinfo.showWatermark) {
              console.log('播放器创建成功');
            // 创建水印元素
              var watermark = document.createElement('div');
              watermark.textContent = this.ra_wxUser.uPhone ? this.ra_wxUser.uPhone : this.ra_wxUser.uId; // 水印文本
              watermark.style.position = 'absolute';
              watermark.style.top = '10px';
              watermark.style.right = '10px';
              watermark.style.color = 'black';
              watermark.style.opacity = '0.5'; // 设置透明度为 50%
              watermark.style.fontSize = '12px';
              watermark.style.zIndex = 999; // 确保水印显示在最上层

              // 获取播放器容器
              var playerContainer = document.getElementById('J_prismPlayer');
              playerContainer.appendChild(watermark);

              // 初始化水印移动参数
              let xSpeed = 1; // x 轴移动速度
              let ySpeed = 1; // y 轴移动速度
              let currentX = parseInt(watermark.style.left) || 0;
              let currentY = parseInt(watermark.style.top) || 0;

              // 定时更新水印位置
              let moveInterval;
              function startMoving() {
                moveInterval = setInterval(() => {
                  // 获取播放器容器的宽度和高度
                  const containerWidth = playerContainer.offsetWidth;
                  const containerHeight = playerContainer.offsetHeight;
                  // 获取水印元素的宽度和高度
                  const watermarkWidth = watermark.offsetWidth;
                  const watermarkHeight = watermark.offsetHeight;

                  // 更新位置
                  currentX += xSpeed;
                  currentY += ySpeed;

                  // 检查边界并改变方向
                  if (currentX + watermarkWidth > containerWidth || currentX < 0) {
                    xSpeed = -xSpeed;
                  }
                  if (currentY + watermarkHeight > containerHeight || currentY < 0) {
                    ySpeed = -ySpeed;
                  }

                  // 更新水印的位置
                  watermark.style.left = currentX + 'px';
                  watermark.style.top = currentY + 'px';
                }, 50);
              }

              function stopMoving() {
                clearInterval(moveInterval);
              }

              // 随机生成 15 - 20 秒的展示时间
              const showTime = Math.floor(Math.random() * (20 - 15 + 1) + 15) * 1000;
              const hideTime = 30 * 1000;

              function showWatermark() {
                watermark.style.display = 'block';
                startMoving();
                setTimeout(() => {
                  hideWatermark();
                }, showTime);
              }

              function hideWatermark() {
                watermark.style.display = 'none';
                stopMoving();
                setTimeout(() => {
                  showWatermark();
                }, hideTime);
              }

              // 开始循环
              showWatermark();

              // // 处理全屏事件，确保全屏时水印也正常显示
            this.chimee.on('fullscreenchange',  ()=> {
              if (this.chimee.isFullscreen()) {
                // 全屏时调整水印样式
                watermark.style.position = 'fixed';
                watermark.style.left = '10px';
                watermark.style.top = '10px';
                currentX = 10;
                currentY = 10;
              } else {
                // 退出全屏时恢复水印样式
                watermark.style.position = 'absolute';
                watermark.style.left = '10px';
                watermark.style.top = '10px';
                currentX = 10;
                currentY = 10;
              }
            })

             }
          }
        );
      }

      // console.log('视频实例化', this.videoinfo.vViewUrl)

      // var _video = document.getElementById('J_prismPlayer');
      // this.chimee.on('play', (e)=> {
      //     _video.removeEventListener('click', this.chimee.play())
      //
      //     _video.addEventListener('click', this.chimee.pause());
      // });
      // this.chimee.on('pause', (e)=> {
      //     _video.removeEventListener('click', this.chimee.pause());
      //     _video.addEventListener('click', this.chimee.play())
      // });

      this.chimee.on("ready", () => {
        this.chimee.pause();
      });

      // console.log('islive', this.$route.query.type == 'video' ? false : this.videoinfo.lState == 3 ? false : true)

      // console.log(this.chimee.$level)
      const originLevel = this.$level;
      // this.$bumpToTop();
      this.$level = originLevel;
      this.chimee.on("beforeSeek", () => {
        return false;
      });
      this.chimee.on("timeupdate", (res) => {
        // console.log(this.chimee.getCurrentTime())
        sessionStorage.setItem("ilnmtime", this.chimee.getCurrentTime());
        // console.log('当前播放时刻',res);
      });
      bus.$on("isstop", (val) => {
        if (val == "stop") {
          this.poster = true;
          this.chimee.pause();
        }
      });

      //去掉快进 觉得不合理
      // this.chimee.on('timeupdate', (val) => {
      //   let time = val.target.currentTime;
      //   if(time - this.last>2){//快进
      //     // console.log('大于')
      //     val.target.currentTime = this.last;
      //     // this.chimee.pause();
      //     // this.chimee.play();
      //   }else{
      //     this.last = time;//没有快进
      //   }
      // console.log('当前时间',val.target.currentTime);
      //    });

      // this.chimee.load({
      //   box:'native',
      //
      // });
      // if(this.$route.query.type=='直播'){
      //   this.chimee.isLive = true;
      // }
      // console.log(this.chimee.isLive);
      // document.querySelectorAll('chimee-progressbar-wrap')[0].style.display = 'none'

      //需要新增是否分享过接口，如果分享过将不再显示，返回的时候需要停止视频播放，返回后再进入分享还是会产生。
      // if (this.videoinfo.vIsShare == 0) {
      //
      //   this.chimee.on('timeupdate', (val) => {
      //     // console.log('当前时间',val.target.currentTime);
      //     // console.log('当前时间',val.target.currentTime);
      //     if (val.target.currentTime >60) {
      //       // console.log(this.$route.query.videoId)
      //       if (localStorage.getItem('share') == this.$route.query.videoId) {
      //         this.poster = false;
      //         this.$emit('shareStates', 'success')
      //
      //         return false;
      //         // this.chimee.play();
      //         // this.chimee.pause();
      //         // console.log(this.weuijsDialog)
      //       } else {
      //         //不强制分享朋友圈
      //         this.$emit('shareStates', 'omg')
      //
      //         // console.log('不等于');
      //         this.poster = true;
      //         this.chimee.pause();
      //       }
      //     }
      //   });
      // }
      //
      // if (this.videoinfo.lIsShare == 0) {
      //
      //   this.chimee.on('timeupdate', (val) => {
      //     // console.log('当前时间',val.target.currentTime);
      //     // console.log('当前时间',val.target.currentTime);
      //     if (val.target.currentTime >60) {
      //       // console.log(this.$route.query.videoId)
      //       if (localStorage.getItem('live_share') == this.$route.query.liveId) {
      //         this.poster = false;
      //         this.$emit('live_shareStates', 'success')
      //
      //         return false;
      //         // this.chimee.play();
      //         // this.chimee.pause();
      //         // console.log(this.weuijsDialog)
      //       } else {
      //         this.$emit('live_shareStates', 'omg')
      //
      //         // console.log('不等于');
      //         this.poster = true;
      //         this.chimee.pause();
      //       }
      //     }
      //   });
      // }

      //         this.chimee.on('liveStreamStop', () => {
      //           //onM3u8Retry	m3u8直播流中断后重试事件，每次断流只触发一次。
      //           //liveStreamStop 将结束的状态传递给父级   直播监听不到ended事件  用次事件来监听直播是否关闭（结束）
      // //           直播流中断时触发。
      // // m3u8/flv/rtmp在重试5次未成功后触发。
      // // 提示上层流中断或需要重新加载视频。
      // // PS：m3u8一直自动重试，不需要上层添加重试。
      //
      //           console.log('直播流中断')
      //           this.chimee.pause();
      //           this.poster = true;
      //           if(this.videoinfo.vIsComplete == 0){//
      //
      //             // this.chimee.pause();
      //             // this.poster = true;
      //
      //           }else{
      //             this.chimee.off('ended', () => {
      //             })
      //           }
      //
      //           this.$emit('ok', 'success')
      //
      //
      //         });
      this.chimee.on("ended", () => {
        //将结束的状态传递给父级   针对视频的监听 结束之后显示调查问卷

        console.log("ended结束");
        this.chimee.pause();
        this.poster = true;
        if (this.videoinfo.vIsComplete == 0) {
          //
          // this.chimee.pause();
          // this.poster = true;
        } else {
          this.chimee.off("ended", () => { });
        }

        this.$emit("ok", "success");
      });
    },
  },
  computed: {
    posterUrl() {
      // let  url = this.videoinfo.vPicUrl||this.videoinfo.lPicUrl;
      // console.log(url)
      let url;
      if (this.$route.query.type == "video") {
        url = this.videoinfo.vPicUrl
          ? this.videoinfo.vPicUrl
          : this.videoinfo.vViewUrl +
          "?x-oss-process=video/snapshot,t_5000,f_jpg,w_800,h_600,m_fast";
      } else {
        console.log();
        url = this.videoinfo.lPicUrl;
      }

      return url;
    },
  },
};
</script>
<style scoped lang="scss">
.mask {
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;

  >div {
    width: 5rem;
    height: 3rem;
    position: fixed;
    z-index: 5000;
    max-width: 300px;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: #fff;
    text-align: center;
    border-radius: 3px;
    overflow: hidden;

    div {
      padding: 0px;
      padding-left: 0.63rem;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      text-align: left;
      height: 0.66rem;
      padding-top: 0.36rem;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: left;
    }
  }
}

.bgoptons {
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0px;
  bottom: 0px;
  z-index: 1000 !important;

  div {
    width: 5rem;
    height: 5rem;
    background: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    margin-top: 3.54rem;
    margin-left: 1.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 3000 !important;

    >ul {
      height: 3.7rem;
      width: 5rem;
      overflow-y: scroll;
      padding: 0.22rem 0.19rem 0px;
      box-sizing: border-box;
    }
  }

  .outline {
    padding: 0.1rem;
    display: flex;
    box-sizing: border-box;
    border-radius: 50%;
    border: 1px solid #0e94ff;

    position: relative;
    margin-right: 0.1rem;
  }

  i {
    position: absolute;
    left: 0.06rem;
    top: 0.06rem;
    border-radius: 50%;
    display: inline-block;
    width: 0.17rem;
    height: 0.17rem;
    /*border: 1px solid #949393;*/
    vertical-align: middle;
    margin-right: 0.1rem;
  }

  .active {
    background: #0e94ff;
    /*padding: 0.1rem;*/
    /*box-sizing: border-box;*/
    display: inline-block;
  }

  &.active {
    i {
      &:after {
        content: "·";
        position: absolute;
        width: 60%;
        height: 60%;
        background-color: #f39800;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .title {
    font-family: 微软雅黑;
    font-weight: bold;
    color: #333333;

    .title_item {
      font-size: 0.28rem;
      font-weight: 500;
      padding-left: 0.37rem;
      box-sizing: border-box;
    }
  }

  .sub_btn {
    width: 1.8rem;
    height: 0.6rem;
    margin: auto;
    border: 1px solid rgba(230, 230, 230, 1);
    background: linear-gradient(0deg,
        rgba(0, 127, 255, 1) 0%,
        rgba(33, 175, 255, 1) 100%);
    border-radius: 5px;
    color: #ffffff;
    outline: none;
  }
}

#J_prismPlayer {
  width: 100%;
  left: -1px;
}

video {
  width: 100%;
  z-index: 1;
}

container {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}

.poster {
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.optionsBg {
  position: absolute;
  width: 100%;
  top: 0px;
  bottom: 0px;
  right: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 0;
}

.poster .live_status {
  position: absolute;
  color: #ffffff;
  display: inline-block;
  right: 0.22rem;
  top: 0.22rem;
  width: 120px;
  height: 46px;
  -webkit-border-radius: 23px;
  -moz-border-radius: 23px;
  border-radius: 23px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.poster .bg {
  width: 100%;
  display: block;
}

.poster .play {
  width: 80px;
  position: absolute;
  top: 50%;
  margin-left: -40px;
  margin-top: -40px;
  left: 50%;
}

video {
  width: 100%;
  height: 100%;
  display: block;
  background-color: #000;
}

video:focus,
video:active {
  outline: none;
}</style>



// WEBPACK FOOTER //
// src/components/container/player.vue